// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== AdminMcpToolsManagement ===== */

.admin-mcp__tabs {
  display: flex;
  gap: 4px;
  border-bottom: 1px solid var(--border-light, #e5e7eb);
  margin-bottom: 24px;
}

.admin-mcp__tab {
  padding: 12px 24px;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-secondary, #6b7280);
  cursor: pointer;
  transition: color 0.15s, border-color 0.15s;
}

.admin-mcp__tab:hover {
  color: var(--text-primary, #1a1a2e);
}

.admin-mcp__tab--active {
  color: var(--primary-600, #9333ea);
  border-bottom-color: var(--primary-600, #9333ea);
}

.admin-mcp__panel {
  padding: 0;
}

.admin-mcp__stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.admin-mcp__stat-card {
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-lg);
  padding: 20px;
  transition: all 0.2s;
}

.admin-mcp__stat-card:hover {
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.35);
  transform: translateY(-2px);
}

.admin-mcp__stat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.admin-mcp__stat-icon {
  width: 40px;
  height: 40px;
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
}

.admin-mcp__stat-icon--total {
  background: rgba(167, 139, 250, 0.1);
  color: #a78bfa;
}

.admin-mcp__stat-icon--active {
  background: var(--admin-success-bg);
  color: var(--admin-success);
}

.admin-mcp__stat-icon--inactive {
  background: var(--admin-error-bg);
  color: var(--admin-error);
}

.admin-mcp__stat-label {
  font-size: 12px;
  color: var(--admin-text-muted);
  margin-bottom: 8px;
}

.admin-mcp__stat-value {
  font-size: 28px;
  font-weight: 700;
  color: var(--admin-text-bright);
  font-variant-numeric: tabular-nums;
}

.admin-mcp__toolbar {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 20px;
}

.admin-mcp__filter {
  padding: 8px 12px;
  border: 1px solid var(--border, #d1d5db);
  border-radius: 6px;
  background: var(--surface, #fff);
  color: var(--text-primary, #1a1a2e);
  font-size: 13px;
  cursor: pointer;
}

.admin-mcp__toolbar-spacer {
  flex: 1 1;
}

.admin-mcp__btn {
  padding: 8px 16px;
  border-radius: 6px;
  border: 1px solid transparent;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}

.admin-mcp__btn--primary {
  background: var(--primary-600, #9333ea);
  color: #fff;
}
.admin-mcp__btn--primary:hover:not(:disabled) {
  background: var(--primary-700, #7e22ce);
}

.admin-mcp__btn--secondary {
  background: var(--surface, #fff);
  border-color: var(--border, #d1d5db);
  color: var(--text-primary, #1a1a2e);
}
.admin-mcp__btn--secondary:hover {
  background: var(--surface-hover, #f9fafb);
}

.admin-mcp__btn--danger {
  background: var(--danger-50, #fef2f2);
  color: var(--danger-600, #dc2626);
  border-color: var(--danger-200, #fecaca);
}
.admin-mcp__btn--danger:hover:not(:disabled) {
  background: var(--danger-100, #fee2e2);
}

.admin-mcp__btn--ghost {
  background: transparent;
  color: var(--text-secondary, #6b7280);
  border-color: var(--border, #d1d5db);
}
.admin-mcp__btn--ghost:hover {
  background: var(--surface-hover, #f9fafb);
}

.admin-mcp__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.admin-mcp__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 16px;
}

.admin-mcp__card {
  background: var(--surface, #fff);
  border: 1px solid var(--border-light, #e5e7eb);
  border-radius: 10px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  transition: box-shadow 0.15s, border-color 0.15s;
}

.admin-mcp__card:hover {
  border-color: var(--primary-300, #d8b4fe);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.admin-mcp__card--inactive {
  opacity: 0.6;
}

.admin-mcp__card-header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.admin-mcp__card-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: var(--primary-50, #faf5ff);
  color: var(--primary-700, #7e22ce);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
}

.admin-mcp__card-title-group {
  flex: 1 1;
  min-width: 0;
}

.admin-mcp__card-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary, #1a1a2e);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.admin-mcp__card-slug {
  font-family: ui-monospace, monospace;
  font-size: 11px;
  color: var(--text-tertiary, #9ca3af);
  margin-top: 2px;
}

.admin-mcp__badge {
  padding: 2px 8px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 500;
  background: var(--surface-hover, #f3f4f6);
  color: var(--text-secondary, #6b7280);
}

.admin-mcp__badge--external { background: #fef3c7; color: #92400e; }
.admin-mcp__badge--web { background: #dbeafe; color: #1e40af; }
.admin-mcp__badge--utility { background: #e0e7ff; color: #3730a3; }
.admin-mcp__badge--compute { background: #dcfce7; color: #166534; }
.admin-mcp__badge--file { background: #fae8ff; color: #86198f; }
.admin-mcp__badge--realtime { background: #fce7f3; color: #9f1239; }
.admin-mcp__badge--system { background: #ede9fe; color: #5b21b6; }
.admin-mcp__badge--partner { background: #cffafe; color: #155e75; }
.admin-mcp__badge--user { background: #fef3c7; color: #92400e; }

.admin-mcp__card-desc {
  font-size: 13px;
  color: var(--text-secondary, #6b7280);
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.admin-mcp__card-meta {
  display: flex;
  gap: 12px;
  font-size: 12px;
  color: var(--text-tertiary, #9ca3af);
}

.admin-mcp__card-actions {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
  padding-top: 12px;
  border-top: 1px solid var(--border-light, #e5e7eb);
}

.admin-mcp__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.admin-mcp__chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  background: var(--primary-50, #faf5ff);
  color: var(--primary-700, #7e22ce);
  border-radius: 4px;
  font-family: ui-monospace, monospace;
  font-size: 11px;
}

.admin-mcp__chip button {
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  font-size: 14px;
  padding: 0;
  line-height: 1;
}

.admin-mcp__toggle {
  width: 36px;
  height: 20px;
  border-radius: 10px;
  background: var(--border, #d1d5db);
  border: none;
  position: relative;
  cursor: pointer;
  transition: background 0.15s;
  flex-shrink: 0;
}

.admin-mcp__toggle--on {
  background: var(--primary-600, #9333ea);
}

.admin-mcp__toggle-thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  transition: transform 0.15s;
}

.admin-mcp__toggle--on .admin-mcp__toggle-thumb {
  transform: translateX(16px);
}

.admin-mcp__empty {
  padding: 48px;
  text-align: center;
  color: var(--text-tertiary, #9ca3af);
  font-size: 14px;
}

.admin-mcp__pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 24px;
  font-size: 13px;
  color: var(--text-secondary, #6b7280);
}

.admin-mcp__pagination button {
  padding: 6px 14px;
  border: 1px solid var(--border, #d1d5db);
  background: var(--surface, #fff);
  border-radius: 6px;
  cursor: pointer;
}

.admin-mcp__pagination button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* Modal */

.admin-mcp__modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 24px;
}

.admin-mcp__modal {
  background: var(--surface, #fff);
  border-radius: 12px;
  width: 100%;
  max-width: 560px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

.admin-mcp__modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid var(--border-light, #e5e7eb);
}

.admin-mcp__modal-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.admin-mcp__modal-close {
  background: none;
  border: none;
  font-size: 24px;
  color: var(--text-tertiary, #9ca3af);
  cursor: pointer;
  line-height: 1;
}

.admin-mcp__modal-body {
  padding: 20px;
  overflow-y: auto;
  flex: 1 1;
}

.admin-mcp__modal-footer {
  padding: 16px 20px;
  border-top: 1px solid var(--border-light, #e5e7eb);
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.admin-mcp__form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 16px;
}

.admin-mcp__form-group > span {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-primary, #1a1a2e);
}

.admin-mcp__form-group input[type="text"],
.admin-mcp__form-group input[type="number"],
.admin-mcp__form-group input[type="password"],
.admin-mcp__form-group select,
.admin-mcp__form-group textarea {
  padding: 8px 12px;
  border: 1px solid var(--border, #d1d5db);
  border-radius: 6px;
  font-size: 13px;
  font-family: inherit;
  background: var(--surface, #fff);
  color: var(--text-primary, #1a1a2e);
}

.admin-mcp__form-group textarea.admin-mcp__json {
  font-family: ui-monospace, monospace;
  font-size: 12px;
  line-height: 1.5;
}

.admin-mcp__form-group--inline {
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-bottom: 0;
}

.admin-mcp__form-row {
  display: flex;
  gap: 16px;
  align-items: center;
}

.admin-mcp__error {
  color: var(--danger-600, #dc2626);
  font-size: 12px;
}

.admin-mcp__chip-input {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 8px;
  border: 1px solid var(--border, #d1d5db);
  border-radius: 6px;
  background: var(--surface, #fff);
  min-height: 40px;
}

.admin-mcp__chip-input input {
  border: none;
  outline: none;
  background: transparent;
  font-size: 13px;
  flex: 1 1;
  min-width: 120px;
}

.admin-mcp__warning {
  padding: 12px;
  background: var(--warning-50, #fffbeb);
  border: 1px solid var(--warning-200, #fde68a);
  border-radius: 6px;
  color: var(--warning-800, #92400e);
  font-size: 13px;
  margin-bottom: 16px;
}

.admin-mcp__test-result {
  padding: 12px;
  border-radius: 6px;
  font-size: 13px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.admin-mcp__test-result--ok {
  background: var(--success-50, #f0fdf4);
  color: var(--success-800, #166534);
  border: 1px solid var(--success-200, #bbf7d0);
}

.admin-mcp__test-result--fail {
  background: var(--danger-50, #fef2f2);
  color: var(--danger-800, #991b1b);
  border: 1px solid var(--danger-200, #fecaca);
}

.admin-mcp__test-result pre {
  background: rgba(0,0,0,0.05);
  padding: 8px;
  border-radius: 4px;
  font-size: 11px;
  overflow-x: auto;
  margin-top: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/css/AdminMcpToolsManagement.css"],"names":[],"mappings":"AAAA,wCAAwC;;AAExC;EACE,aAAa;EACb,QAAQ;EACR,qDAAqD;EACrD,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,gDAAgD;AAClD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,wCAAwC;EACxC,kBAAkB;EAClB,gCAAgC;EAChC,mCAAmC;EACnC,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,uCAAuC;EACvC,WAAW;AACb;AACA;EACE,uCAAuC;AACzC;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,mCAAmC;AACrC;AACA;EACE,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,wCAAwC;AAC1C;AACA;EACE,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,oCAAoC;AACtC;AACA;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,8CAA8C;EAC9C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gDAAgD;AAClD;;AAEA;EACE,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA,8BAA8B,mBAAmB,EAAE,cAAc,EAAE;AACnE,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;AAC9D,6BAA6B,mBAAmB,EAAE,cAAc,EAAE;AAClE,6BAA6B,mBAAmB,EAAE,cAAc,EAAE;AAClE,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;AAC/D,8BAA8B,mBAAmB,EAAE,cAAc,EAAE;AACnE,4BAA4B,mBAAmB,EAAE,cAAc,EAAE;AACjE,6BAA6B,mBAAmB,EAAE,cAAc,EAAE;AAClE,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;;AAE/D;EACE,eAAe;EACf,qCAAqC;EACrC,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,sCAAsC;EACtC,kCAAkC;EAClC,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,wCAAwC;EACxC,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,UAAU;;AAEV;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,oCAAoC;EACpC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;;;;;EAKE,iBAAiB;EACjB,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,6CAA6C;EAC7C,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":["/* ===== AdminMcpToolsManagement ===== */\n\n.admin-mcp__tabs {\n  display: flex;\n  gap: 4px;\n  border-bottom: 1px solid var(--border-light, #e5e7eb);\n  margin-bottom: 24px;\n}\n\n.admin-mcp__tab {\n  padding: 12px 24px;\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-secondary, #6b7280);\n  cursor: pointer;\n  transition: color 0.15s, border-color 0.15s;\n}\n\n.admin-mcp__tab:hover {\n  color: var(--text-primary, #1a1a2e);\n}\n\n.admin-mcp__tab--active {\n  color: var(--primary-600, #9333ea);\n  border-bottom-color: var(--primary-600, #9333ea);\n}\n\n.admin-mcp__panel {\n  padding: 0;\n}\n\n.admin-mcp__stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.admin-mcp__stat-card {\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-lg);\n  padding: 20px;\n  transition: all 0.2s;\n}\n\n.admin-mcp__stat-card:hover {\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.35);\n  transform: translateY(-2px);\n}\n\n.admin-mcp__stat-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.admin-mcp__stat-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius-md);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.admin-mcp__stat-icon--total {\n  background: rgba(167, 139, 250, 0.1);\n  color: #a78bfa;\n}\n\n.admin-mcp__stat-icon--active {\n  background: var(--admin-success-bg);\n  color: var(--admin-success);\n}\n\n.admin-mcp__stat-icon--inactive {\n  background: var(--admin-error-bg);\n  color: var(--admin-error);\n}\n\n.admin-mcp__stat-label {\n  font-size: 12px;\n  color: var(--admin-text-muted);\n  margin-bottom: 8px;\n}\n\n.admin-mcp__stat-value {\n  font-size: 28px;\n  font-weight: 700;\n  color: var(--admin-text-bright);\n  font-variant-numeric: tabular-nums;\n}\n\n.admin-mcp__toolbar {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.admin-mcp__filter {\n  padding: 8px 12px;\n  border: 1px solid var(--border, #d1d5db);\n  border-radius: 6px;\n  background: var(--surface, #fff);\n  color: var(--text-primary, #1a1a2e);\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.admin-mcp__toolbar-spacer {\n  flex: 1;\n}\n\n.admin-mcp__btn {\n  padding: 8px 16px;\n  border-radius: 6px;\n  border: 1px solid transparent;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s;\n}\n\n.admin-mcp__btn--primary {\n  background: var(--primary-600, #9333ea);\n  color: #fff;\n}\n.admin-mcp__btn--primary:hover:not(:disabled) {\n  background: var(--primary-700, #7e22ce);\n}\n\n.admin-mcp__btn--secondary {\n  background: var(--surface, #fff);\n  border-color: var(--border, #d1d5db);\n  color: var(--text-primary, #1a1a2e);\n}\n.admin-mcp__btn--secondary:hover {\n  background: var(--surface-hover, #f9fafb);\n}\n\n.admin-mcp__btn--danger {\n  background: var(--danger-50, #fef2f2);\n  color: var(--danger-600, #dc2626);\n  border-color: var(--danger-200, #fecaca);\n}\n.admin-mcp__btn--danger:hover:not(:disabled) {\n  background: var(--danger-100, #fee2e2);\n}\n\n.admin-mcp__btn--ghost {\n  background: transparent;\n  color: var(--text-secondary, #6b7280);\n  border-color: var(--border, #d1d5db);\n}\n.admin-mcp__btn--ghost:hover {\n  background: var(--surface-hover, #f9fafb);\n}\n\n.admin-mcp__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.admin-mcp__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 16px;\n}\n\n.admin-mcp__card {\n  background: var(--surface, #fff);\n  border: 1px solid var(--border-light, #e5e7eb);\n  border-radius: 10px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  transition: box-shadow 0.15s, border-color 0.15s;\n}\n\n.admin-mcp__card:hover {\n  border-color: var(--primary-300, #d8b4fe);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.admin-mcp__card--inactive {\n  opacity: 0.6;\n}\n\n.admin-mcp__card-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.admin-mcp__card-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  background: var(--primary-50, #faf5ff);\n  color: var(--primary-700, #7e22ce);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  flex-shrink: 0;\n}\n\n.admin-mcp__card-title-group {\n  flex: 1;\n  min-width: 0;\n}\n\n.admin-mcp__card-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary, #1a1a2e);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.admin-mcp__card-slug {\n  font-family: ui-monospace, monospace;\n  font-size: 11px;\n  color: var(--text-tertiary, #9ca3af);\n  margin-top: 2px;\n}\n\n.admin-mcp__badge {\n  padding: 2px 8px;\n  border-radius: 9999px;\n  font-size: 11px;\n  font-weight: 500;\n  background: var(--surface-hover, #f3f4f6);\n  color: var(--text-secondary, #6b7280);\n}\n\n.admin-mcp__badge--external { background: #fef3c7; color: #92400e; }\n.admin-mcp__badge--web { background: #dbeafe; color: #1e40af; }\n.admin-mcp__badge--utility { background: #e0e7ff; color: #3730a3; }\n.admin-mcp__badge--compute { background: #dcfce7; color: #166534; }\n.admin-mcp__badge--file { background: #fae8ff; color: #86198f; }\n.admin-mcp__badge--realtime { background: #fce7f3; color: #9f1239; }\n.admin-mcp__badge--system { background: #ede9fe; color: #5b21b6; }\n.admin-mcp__badge--partner { background: #cffafe; color: #155e75; }\n.admin-mcp__badge--user { background: #fef3c7; color: #92400e; }\n\n.admin-mcp__card-desc {\n  font-size: 13px;\n  color: var(--text-secondary, #6b7280);\n  line-height: 1.5;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.admin-mcp__card-meta {\n  display: flex;\n  gap: 12px;\n  font-size: 12px;\n  color: var(--text-tertiary, #9ca3af);\n}\n\n.admin-mcp__card-actions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  flex-wrap: wrap;\n  padding-top: 12px;\n  border-top: 1px solid var(--border-light, #e5e7eb);\n}\n\n.admin-mcp__chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.admin-mcp__chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  background: var(--primary-50, #faf5ff);\n  color: var(--primary-700, #7e22ce);\n  border-radius: 4px;\n  font-family: ui-monospace, monospace;\n  font-size: 11px;\n}\n\n.admin-mcp__chip button {\n  background: none;\n  border: none;\n  color: inherit;\n  cursor: pointer;\n  font-size: 14px;\n  padding: 0;\n  line-height: 1;\n}\n\n.admin-mcp__toggle {\n  width: 36px;\n  height: 20px;\n  border-radius: 10px;\n  background: var(--border, #d1d5db);\n  border: none;\n  position: relative;\n  cursor: pointer;\n  transition: background 0.15s;\n  flex-shrink: 0;\n}\n\n.admin-mcp__toggle--on {\n  background: var(--primary-600, #9333ea);\n}\n\n.admin-mcp__toggle-thumb {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #fff;\n  transition: transform 0.15s;\n}\n\n.admin-mcp__toggle--on .admin-mcp__toggle-thumb {\n  transform: translateX(16px);\n}\n\n.admin-mcp__empty {\n  padding: 48px;\n  text-align: center;\n  color: var(--text-tertiary, #9ca3af);\n  font-size: 14px;\n}\n\n.admin-mcp__pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  margin-top: 24px;\n  font-size: 13px;\n  color: var(--text-secondary, #6b7280);\n}\n\n.admin-mcp__pagination button {\n  padding: 6px 14px;\n  border: 1px solid var(--border, #d1d5db);\n  background: var(--surface, #fff);\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.admin-mcp__pagination button:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* Modal */\n\n.admin-mcp__modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 24px;\n}\n\n.admin-mcp__modal {\n  background: var(--surface, #fff);\n  border-radius: 12px;\n  width: 100%;\n  max-width: 560px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n}\n\n.admin-mcp__modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--border-light, #e5e7eb);\n}\n\n.admin-mcp__modal-header h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.admin-mcp__modal-close {\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: var(--text-tertiary, #9ca3af);\n  cursor: pointer;\n  line-height: 1;\n}\n\n.admin-mcp__modal-body {\n  padding: 20px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.admin-mcp__modal-footer {\n  padding: 16px 20px;\n  border-top: 1px solid var(--border-light, #e5e7eb);\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.admin-mcp__form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 16px;\n}\n\n.admin-mcp__form-group > span {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-primary, #1a1a2e);\n}\n\n.admin-mcp__form-group input[type=\"text\"],\n.admin-mcp__form-group input[type=\"number\"],\n.admin-mcp__form-group input[type=\"password\"],\n.admin-mcp__form-group select,\n.admin-mcp__form-group textarea {\n  padding: 8px 12px;\n  border: 1px solid var(--border, #d1d5db);\n  border-radius: 6px;\n  font-size: 13px;\n  font-family: inherit;\n  background: var(--surface, #fff);\n  color: var(--text-primary, #1a1a2e);\n}\n\n.admin-mcp__form-group textarea.admin-mcp__json {\n  font-family: ui-monospace, monospace;\n  font-size: 12px;\n  line-height: 1.5;\n}\n\n.admin-mcp__form-group--inline {\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 0;\n}\n\n.admin-mcp__form-row {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n}\n\n.admin-mcp__error {\n  color: var(--danger-600, #dc2626);\n  font-size: 12px;\n}\n\n.admin-mcp__chip-input {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  padding: 8px;\n  border: 1px solid var(--border, #d1d5db);\n  border-radius: 6px;\n  background: var(--surface, #fff);\n  min-height: 40px;\n}\n\n.admin-mcp__chip-input input {\n  border: none;\n  outline: none;\n  background: transparent;\n  font-size: 13px;\n  flex: 1;\n  min-width: 120px;\n}\n\n.admin-mcp__warning {\n  padding: 12px;\n  background: var(--warning-50, #fffbeb);\n  border: 1px solid var(--warning-200, #fde68a);\n  border-radius: 6px;\n  color: var(--warning-800, #92400e);\n  font-size: 13px;\n  margin-bottom: 16px;\n}\n\n.admin-mcp__test-result {\n  padding: 12px;\n  border-radius: 6px;\n  font-size: 13px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.admin-mcp__test-result--ok {\n  background: var(--success-50, #f0fdf4);\n  color: var(--success-800, #166534);\n  border: 1px solid var(--success-200, #bbf7d0);\n}\n\n.admin-mcp__test-result--fail {\n  background: var(--danger-50, #fef2f2);\n  color: var(--danger-800, #991b1b);\n  border: 1px solid var(--danger-200, #fecaca);\n}\n\n.admin-mcp__test-result pre {\n  background: rgba(0,0,0,0.05);\n  padding: 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  overflow-x: auto;\n  margin-top: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
